import React from "react";
import { KpiStrip, Kpi } from '../../components/card';
import currencyFormat from "../../functions/currency";
export default class extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    var activity = this.props.activity;
    return /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total",
      value: currencyFormat(activity.total, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Users",
      value: currencyFormat(activity.users, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: currencyFormat(activity.sessions, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Value",
      value: currencyFormat(activity.value)
    }));
  }
}